<template>
  <div>
    <modal-team-update 
      :id="this.id" 
      :name="this.name"
      :owner="this.owner[0].first_name + ' ' + this.owner[0].last_name"
      :description="this.description"
    />
    <div class="text-center items-center justify-center relative min-w-0 bg-white w-full h-full shadow-lg rounded-lg">
      <div class="px-4 py-5 items-center">
        <div
          class="mt-5 text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-lg"
        >
          <img
            class="shadow-xl rounded-full h-auto align-middle border-none absolute"
            alt="Team"
            :src="image"
            width="85"
            height="85"
          />
        </div>
        <h6 class="mt-3 text-xl font-semibold">{{name}}</h6>
        <p class="mt-5 mb-4 text-gray-600 font-semibold">
          {{
            owner[0].first_name +
            " " +
            owner[0].last_name
          }}
        </p>
        <p class="mt-2 mb-4 text-gray-600">
          {{description}}
        </p>
        <div class="flex flex-wrap mt-6 justify-center">
           <div class="w-full xl:w-6/12 mb-12 xl:mb-0 px-2">
            <FormulateInput
              type="submit"
              name="Update"
              outer-class="mb-4"
              input-class="px-4 py-2 w-full bg-blue-500 text-white hover:bg-blue-700 rounded"
              label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
              help-class="text-xs mb-1 text-gray-600"
              error-class="text-red-700 text-xs mb-1"
              @click="updateTeam"
            />
          </div>
          <div class="w-full xl:w-6/12 mb-12 xl:mb-0 px-2">
            <FormulateInput
              type="submit"
              name="Delete"
              outer-class="mb-4"
              input-class="px-4 py-2 w-full bg-blue-500 text-white hover:bg-blue-700 rounded"
              label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
              help-class="text-xs mb-1 text-gray-600"
              error-class="text-red-700 text-xs mb-1"
              @click="deleteTeam"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* 
  Class: CardTeam
  Description: This class representing a cards with single team.
*/

/* Imports */
import TeamService from "@/services/team.service";
import ModalTeamUpdate from "@/components/Modals/Teams/ModalTeamUpdate.vue";
/* /Imports/ */

export default {
  /* 
    Define props from which we got team id, image, name, owner, description. 
  */
  props: {
    id: null,
    image: null,
    name: null,
    owner: null,
    description: null,
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    ModalTeamUpdate,
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Show modal for update team. 
    */
    updateTeam() {
      this.$modal.show("team-update");
    },

    /* 
      Show alert for delete team. 
    */
    deleteTeam() {
      if (confirm("Are you sure you want to delete the team?")) {
        TeamService.deleteTeam(this.id).then(() => {
           this.$router.push({name: 'Teams'});
        });
      }
    },
  }
};
</script>
